import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import {
  Button,
  BUTTON_THEME,
  Icon,
  IconButton,
  ICON_TYPES,
  Card,
  Divider,
} from '@st-operations/uikit/src/v2/index.js'
import toast from '@st-operations/uikit/lib/toast.js'

import { useDropdown, useModal } from '_hooks'
import Header from '_components/header/index.jsx'
import TitleEditor from '_components/title-editor/index.jsx'
import MoreInfoDropdown from '_components/more-info-dropdown/index.jsx'
import DeliveryModal from '../delivery-modal/index.jsx'

import './styles.scss'

export const STATUSES = {
  DRAFT: 'draft',
  DELIVERED: 'delivered',
}

const UnifiedUserProfileHeader = ({ schema, data, loading, onSave, onDelete }) => {
  const moreInfo = useDropdown()
  const moreOptions = useDropdown()
  const deliveryModal = useModal()

  function requiredFieldsMetForDelivery() {
    return data.primaryKey && data.datasources?.length
  }

  function handleSubmitDelivery() {
    if (!requiredFieldsMetForDelivery()) {
      toast.error('Please fill in required fields before delivery')
      return
    }
    deliveryModal.handleOpenModal()
  }

  return (
    <>
      <Header className="unified-user-profile__header">
        <div className="unified-user-profile-header">
          <TitleEditor title={data?.name} onTitleSubmit={(name) => onSave?.({ ...data, name })} />
          <Link to="/unified-user-profile">
            <Button className="unified-user-profile-header__button" theme={BUTTON_THEME.GHOST}>
              Exit
            </Button>
          </Link>
          <Button
            className="unified-user-profile-header__button"
            theme={BUTTON_THEME.SECONDARY}
            disabled={loading}
            isLoading={loading}
            onClick={handleSubmitDelivery}
          >
            {data?.status === 'draft' ? 'Submit delivery' : 'Edit delivery'}
          </Button>
          <Button
            className="unified-user-profile-header__button"
            disabled={loading}
            isLoading={loading}
            onClick={() => onSave?.(data)}
          >
            Save Changes
          </Button>

          <IconButton
            className="unified-user-profile-header__more-options"
            onClick={moreOptions.handleOpen}
            isActive={moreOptions.isOpen}
            aria-label="See more options"
            iconProps={{
              icon: 'more',
              type: ICON_TYPES.FILL,
              width: '32px',
              height: '32px',
            }}
            text="More options"
          />
          <Divider vertical className={'unified-user-profile-header__button-divider'} />
          <IconButton
            className="unified-user-profile-header__more-info"
            onClick={moreInfo.handleOpen}
            isActive={moreInfo.isOpen}
            aria-label="See additional help"
            iconProps={{
              icon: 'info',
              type: ICON_TYPES.OUTLINE,
              width: '32px',
              height: '32px',
            }}
            text="More info"
          />

          <If condition={moreOptions.isOpen}>
            <Card
              component="ul"
              className="unified-user-profile-header__dropdown"
              ref={moreOptions.dropdownRef}
            >
              <li>
                <Button
                  theme={BUTTON_THEME.GHOST}
                  className="unified-user-profile-header__dropdown-option"
                  onClick={onDelete}
                  isLoading={loading}
                >
                  <Icon type="outline" icon="trashcan" color="#3D3D3D" width="24px" height="24px" />
                  Delete
                </Button>
              </li>
            </Card>
          </If>
          <If condition={moreInfo.isOpen}>
            <MoreInfoDropdown ref={moreInfo.dropdownRef} onClose={moreInfo.handleClose} />
          </If>
          <DeliveryModal
            open={deliveryModal.isOpen}
            schema={schema}
            data={data}
            onClose={deliveryModal.handleCloseModal}
            onSave={onSave}
          />
        </div>
      </Header>
    </>
  )
}

UnifiedUserProfileHeader.propTypes = {
  title: PropTypes.string,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  loading: PropTypes.shape({
    isSaving: PropTypes.bool,
    isDeleting: PropTypes.bool,
  }),
}

UnifiedUserProfileHeader.defaultProps = {
  title: '',
  onSave: () => {},
  onDelete: () => {},
  loading: {
    isSaving: false,
    isDeleting: false,
  },
}

export default UnifiedUserProfileHeader
